import { useEffect, useState } from "react";
import { RefreshCw, ExternalLink } from "react-feather";

export default function SuporteRedirectPage() {
    const [seconds, setSeconds] = useState(10);
    const newUrl = "https://suporte.distribuidorayork.com.br";

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    window.location.href = newUrl;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center px-4">
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center">

                {/* Ícone animado */}
                <div className="flex justify-center mb-6">
                    <RefreshCw className="w-12 h-12 text-blue-500 animate-spin" />
                </div>

                {/* Título */}
                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    Endereço alterado!
                </h1>

                {/* Texto */}
                <p className="text-gray-600 mb-6">
                    Você será redirecionado automaticamente em{" "}
                    <span className="font-bold text-blue-500">{seconds}</span> segundos
                </p>

                {/* Barra de progresso */}
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                        className="bg-blue-500 h-2.5 rounded-full transition-all duration-1000"
                        style={{ width: `${seconds * 10}%` }} 
                    ></div>
                </div>

                {/* Link manual */}
                <div className="mt-8">
                    <button
                        onClick={() => (window.location.href = newUrl)}
                        className="text-blue-500 hover:text-blue-700 flex items-center justify-center gap-2"
                    >
                        <ExternalLink className="w-4 h-4" />
                        <span>Se o redirecionamento não funcionar, clique aqui</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
